// One palette for submission states and league tiers, shared by every card,
// chip and heatmap (VISUAL_IDENTITY §4.11). Class strings stay literal so
// Tailwind's JIT sees them.
export const SUBMISSION_STATE = {
  ready: { dot: 'bg-green-500', cell: 'bg-green-500 dark:bg-green-400', label: 'Submitted' },
  pending: { dot: 'bg-amber-500', cell: 'bg-amber-400 dark:bg-amber-500', label: 'Open' },
  missed: { dot: 'bg-gray-200 border border-gray-300 dark:bg-gray-800 dark:border-gray-600', cell: 'bg-gray-200 border border-gray-300 dark:bg-gray-800 dark:border-gray-600', label: 'Missed' },
  locked: { dot: 'bg-gray-300 dark:bg-gray-600', cell: 'bg-gray-200 dark:bg-gray-700', label: 'Locked' },
};

const LEAGUE_TIER = {
  elite: { label: 'Elite', text: 'text-brand-700 dark:text-brand-300', chip: 'bg-brand-100 text-brand-800 dark:bg-brand-900/50 dark:text-brand-200' },
  challenger: { label: 'Challenger', text: 'text-brand-600 dark:text-brand-400', chip: 'border border-brand-200 bg-brand-50 text-brand-700 dark:border-brand-800 dark:bg-brand-900/20 dark:text-brand-300' },
  runner_up: { label: 'Runner-up', text: 'text-slate-700 dark:text-slate-300', chip: 'bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-200' },
  unassigned: { label: 'Contender', text: 'text-gray-700 dark:text-gray-300', chip: 'border border-gray-200/70 text-gray-600 dark:border-gray-600/70 dark:text-gray-300' },
  unqualified: { label: 'Unqualified', text: 'text-red-700 dark:text-red-400', chip: 'bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-300' },
};

const PENDING = { label: 'Pending', text: 'text-gray-600 dark:text-gray-300', chip: LEAGUE_TIER.unassigned.chip };

export const leagueTier = (leagueId) => LEAGUE_TIER[leagueId] || PENDING;
